<template>
  <div class="opc-zm-base-card__head">
    <div class="opc-zm-base-card__head-left">
      <img class="opc-zm-base-card__logo" :src="logo" :alt="title" tabindex="-1" />
    </div>
    <div class="opc-zm-base-card__head-right">
      <h1 class="opc-zm-base-card__name text-capitalize">
        {{ title }}
        <i v-if="ready" class="zm-icon-success main-icon"></i>
      </h1>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: Object,
      default: () => {},
    },
    title: String,
    ready: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
